import { render, staticRenderFns } from "./CardPreview.vue?vue&type=template&id=5f40312a&scoped=true&"
import script from "./CardPreview.vue?vue&type=script&lang=ts&"
export * from "./CardPreview.vue?vue&type=script&lang=ts&"
import style0 from "./CardPreview.vue?vue&type=style&index=0&id=5f40312a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f40312a",
  null
  
)

export default component.exports